export function Logo() {
  return <img src="/logo.png" className="h-12" />;
}
